import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { EapSettingsFormGeneralModel } from './eap-settings-form-general.model';

export const mapEapSettingsToFormGeneral = (eapSettings: EapSettings | null): EapSettingsFormGeneralModel => ({
    name: eapSettings?.name || '',
    ssid: eapSettings?.ssid || '',
    cipherType: eapSettings?.cipherType || 'AES',
});
